import logo from '../assets/logo.jpg';

export default function Header({onContactClick}) {
  return (
    <header className="site-header" role="banner">
      <div className="container header-row">
        <a href="/" className="brand" aria-label="AD Furnished Home">
          <img src={logo} width="36" height="36" alt="AD Furnished logo" />
          <span className="brand-name">AD Furnished</span>
        </a>
        <button className="contact-btn" onClick={onContactClick} aria-label="Contact us">
          Contact Us
        </button>
        {/* <nav className="nav" aria-label="primary">
          <a href="#contact-us">Contact us</a>
          {/* <a href="#catalog">Catalog</a>
          <a href="#pricing">Pricing</a> }
        </nav> */}
      </div>
    </header>
  );
}


